// @flow
import snakeCase from 'lodash/snakeCase'
export const snakeUpperCase = (str: string) => snakeCase(str).toUpperCase()

export const createAction = (type: string) => (data: any) => ({ type, payload: { data } })

const createCRUDActions = (name: string, methods: string[] = []) => {
  if (typeof name !== 'string' || name === '') {
    throw new Error('Name should be a string')
  }
  if (!Array.isArray(methods)) {
    throw new Error('Methods should be an array')
  }
  if (methods.length === 0) {
    throw new Error('Methods should not be empty')
  }
  const statuses = ['request', 'success', 'fail']
  const actions = {}
  const actionTypes = {}
  methods.map(method => {
    if (typeof method !== 'string' || method === '') {
      throw new Error('Method should be a string')
    }
    const actionsScope = {}
    const actionTypesScope = {}
    statuses.forEach(status => {
      const postFix = `${method}_${status}`
      const currentActionType = `${snakeUpperCase(name)}/${snakeUpperCase(postFix)}`
      actionTypesScope[snakeUpperCase(status)] = currentActionType
      actionsScope[status] = createAction(currentActionType)
    })
    actions[method] = actionsScope
    actionTypes[snakeUpperCase(method)] = actionTypesScope
  })
  return {
    actions,
    actionTypes,
  }
}

export { createCRUDActions }
